var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineCloudAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.54 19.34c-2.94-.21-4.26-2.47-4.26-4.48 0-2.01 1.32-4.28 4.21-4.48.41-.04.77.28.8.7a.75.75 0 0 1-.7.8c-1.94.14-2.81 1.6-2.81 2.99 0 1.39.87 2.85 2.81 2.99h1.87c.41 0 .75.34.75.75s-.34.73-.75.73H5.54z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.62 19.34c-.41 0-.79-.34-.79-.75 0-.43.32-.75.74-.75 1.23 0 2.33-.43 3.19-1.2 1.56-1.36 1.66-3.32 1.24-4.7-.42-1.37-1.59-2.94-3.63-3.19a.753.753 0 0 1-.65-.62c-.4-2.4-1.69-4.06-3.65-4.66-2.02-.63-4.38-.01-5.85 1.53-1.43 1.49-1.76 3.58-.93 5.88a.75.75 0 1 1-1.41.51c-1.01-2.82-.55-5.52 1.26-7.42 1.85-1.94 4.82-2.71 7.37-1.93 2.34.72 3.99 2.65 4.59 5.33 2.04.46 3.68 2.01 4.33 4.15.71 2.33.07 4.73-1.68 6.25-1.11 1-2.56 1.57-4.08 1.57h-.05z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08 19.48c-.11-.17-.22-.37-.31-.59-.34-.71-.52-1.52-.52-2.36 0-3.17 2.58-5.75 5.75-5.75s5.75 2.58 5.75 5.75c0 .85-.18 1.65-.54 2.39-.08.19-.19.39-.31.58a5.712 5.712 0 0 1-4.9 2.78c-2.01 0-3.89-1.07-4.92-2.8zm.67-2.95c0 .62.13 1.2.38 1.73.08.17.15.31.23.44a4.227 4.227 0 0 0 3.63 2.08c1.48 0 2.87-.79 3.62-2.06.09-.15.17-.29.23-.43.27-.55.4-1.13.4-1.75.01-2.35-1.9-4.26-4.24-4.26a4.26 4.26 0 0 0-4.25 4.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.9 18.05-.99-.99a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l.48.48 1.6-1.48c.31-.28.78-.26 1.06.04s.26.78-.04 1.06l-2.13 1.97c-.15.13-.33.2-.51.2-.19 0-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCloudAdd);
export default __webpack_public_path__ + "static/media/vuesax-outline-cloud-add.b25736e77bce351cc860ec26ef095c31.svg";
export { ForwardRef as ReactComponent };